import WebModel from '../../models/WebModel'

export namespace PnG {
  const defaultDelay = 3000

  export const writePixel = (
    model: WebModel,
    gdpr: IGDPR,
    delay = defaultDelay
  ): void => {
    setTimeout(async () => {
      const src = await getSrc(model, gdpr)
      const pixel = getPixel(src)
      document.body.appendChild(pixel)
    }, delay)
  }

  export const getPixel = (src: string): HTMLImageElement => {
    const pixel = document.createElement('img')
    pixel.setAttribute('height', '1')
    pixel.setAttribute('width', '1')
    pixel.setAttribute('style', 'display: none')
    pixel.setAttribute('src', src)

    return pixel
  }

  export const getSrc = async (
    model: WebModel,
    gdpr: IGDPR
  ): Promise<string> => {
    const cachebuster = Date.now()
    let tcfString = ''
    if (gdpr.enableGdpr) {
      const { TCF } = await import(
        /* webpackChunkName: "gdpr"*/ '../../cmp/tcf/TCF'
      )
      tcfString = TCF.tcString
    }

    const params = {
      bpid: 'mediavine',
      loc: document.location.href,
      cat: getPrimaryCat(model),
      subcat: getSecondaryCat(model),
      gdpr: gdpr.enableGdpr ? '1' : '0',
      gdpr_consent: tcfString
    }
    return `https://d.agkn.com/pixel/8613/?che=${cachebuster}&c=${encodeURIComponent(
      JSON.stringify(params)
    )}`
  }

  export const getPrimaryCat = (model: WebModel) =>
    encodeURIComponent(model.topLevelCategory.slug)
  export const getSecondaryCat = (
    model: WebModel,
    isTLCat = PnG.siteCategoryIsATopLevelCat(model)
  ) => (isTLCat ? encodeURIComponent(model.category.slug) : '')
  export const siteCategoryIsATopLevelCat = (model: WebModel) =>
    model.category.slug !== model.topLevelCategory.slug
}
